/* Generieke overlay-variant — laat alle laatste events per type zien.
   Bedoeld als debug/scaffolding: als een specifieke game-variant nog niet
   bestaat, ziet OBS in ieder geval welke events er binnenkomen.
   Plus: als channel aan een tournament_match hangt (context), toont een
   nette header met team-namen + toernooi-info. */

export default function GenericOverlayVariant({ byType, context }) {
  const entries = Object.entries(byType || {})
  const hasCtx = !!context?.team_a || !!context?.team_b || !!context?.tournament
  return (
    <>
      {hasCtx && <ContextHeader context={context} />}
      {entries.length === 0 ? (
        <div style={box}>
          <div style={label}>Overlay wacht op events…</div>
        </div>
      ) : (
        <div style={box}>
          {entries.map(([type, ev]) => (
            <div key={type} style={row}>
              <div style={label}>{type}</div>
              <pre style={code}>{JSON.stringify(ev.data, null, 2)}</pre>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

function ContextHeader({ context }) {
  const t = context.tournament
  const m = context.match
  const a = context.team_a?.name || 'Team A'
  const b = context.team_b?.name || 'Team B'
  return (
    <div style={ctxHeader}>
      <span style={ctxTitle}>{a} <span style={{ color: '#94A3B8' }}>vs</span> {b}</span>
      <span style={ctxMeta}>
        {t?.name}{m?.round ? ` · R${m.round}·M${m.match_number}` : ''}
      </span>
    </div>
  )
}

const box   = { position: 'fixed', bottom: 24, left: 24, right: 24,
                display: 'flex', flexDirection: 'column', gap: 8,
                fontFamily: 'system-ui, sans-serif' }
const row   = { background: 'rgba(0,0,0,.72)', border: '1px solid rgba(180,255,57,.3)',
                borderRadius: 6, padding: '8px 12px' }
const label = { fontFamily: 'monospace', fontSize: 10, letterSpacing: '.2em',
                textTransform: 'uppercase', color: '#B4FF39' }
const code  = { fontFamily: 'monospace', fontSize: 11, margin: '4px 0 0', color: '#eee' }
const ctxHeader = {
  position: 'fixed', top: 12, left: '50%', transform: 'translateX(-50%)',
  display: 'flex', alignItems: 'center', gap: 14,
  padding: '6px 16px', background: 'rgba(0,0,0,.72)',
  border: '1px solid rgba(180,255,57,.28)', borderRadius: 6,
  backdropFilter: 'blur(4px)',
}
const ctxTitle = {
  fontFamily: 'system-ui, sans-serif', fontSize: 14, fontWeight: 700, color: '#fff',
}
const ctxMeta = {
  fontFamily: 'monospace', fontSize: 10, letterSpacing: '.18em', textTransform: 'uppercase',
  color: '#B4FF39',
}
